import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/EditorialMarquee";
import Manifesto from "@/components/landing/Manifesto";
import Services from "@/components/landing/Services";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import ContactSection from "@/components/landing/ContactSection";
import FounderSection from "@/components/landing/FounderSection";
import Footer from "@/components/landing/Footer";

export default function LandingPage({ openBooking }) {
  return (
    <main data-testid="tybra-landing-page" className="relative min-h-screen overflow-hidden bg-[#08080C] text-slate-100">
      <div className="noise-layer" aria-hidden="true" />
      <Navbar openBooking={openBooking} />
      <Hero openBooking={openBooking} />
      <EditorialMarquee />
      <Manifesto />
      <Services />
      <Pricing openBooking={openBooking} />
      <FAQ />
      <ContactSection openBooking={openBooking} />
      <FounderSection openBooking={openBooking} />
      <Footer />
    </main>
  );
}
